export const REVIEW_STATUS_LABEL = {
    accepted: "Accepted",
    edited: "Edited",
    rejected: "Rejected",
}

export function userEditedTypeAndParent(row) {
    const currentTypeName = row.reviewedTypeName ?? row.suggestedTypeName
    const currentParent = row.reviewedParent ?? row.suggestedParent
    return currentTypeName !== row.suggestedTypeName || currentParent !== row.suggestedParent
}

export function getReviewStatusLabel(row) {
    if (row.reviewStatus === "rejected") return REVIEW_STATUS_LABEL.rejected
    if (row.reviewStatus !== "approved") return ""
    return userEditedTypeAndParent(row) ? REVIEW_STATUS_LABEL.edited : REVIEW_STATUS_LABEL.accepted
}
